export default __webpack_public_path__ + "static/media/featured-item-2.d7ec2f55.png";